/** Where the campaign pages live. Link to these rather than spelling the paths out. */
export const CAMPAIGNS_LIST_PATH = '/admin/marketing/campaigns';
export const NEW_CAMPAIGN_PATH = `${CAMPAIGNS_LIST_PATH}/new`;

export function campaignEditPath(id: string): string {
  return `${CAMPAIGNS_LIST_PATH}/${encodeURIComponent(id)}`;
}
